import { escapeODataString, odataFilterParam } from '../lib/odataQuery';
import { normalizeMobileNumber } from '../config/keyRequest';

const MOBIL_LOG_SELECT =
  'oc_mobillogid,oc_direction,oc_mobilenumber,oc_userid,oc_email,oc_name,oc_timestamp,oc_deviceid';

function toODataDate(iso) {
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }
  return parsed.toISOString().replace(/\.\d{3}Z$/, 'Z');
}

function mapMobilLog(record) {
  return {
    id: record.oc_mobillogid,
    direction: record.oc_direction,
    mobileNumber: record.oc_mobilenumber || '',
    userId: record.oc_userid || '',
    email: record.oc_email || '',
    name: record.oc_name || '',
    timestamp: record.oc_timestamp || record.createdon || null,
    deviceId: record.oc_deviceid || ''
  };
}

export function createMobilLogService(dataverseApiCall) {
  return {
    /**
     * oc_direction: false = innlogging, true = utlogging (samme som MobilLogon/Logoff).
     */
    create: async ({
      direction,
      mobileNumber,
      userId = '',
      email = '',
      name = '',
      deviceId = '',
      timestamp = new Date().toISOString()
    }) => {
      const mobile = normalizeMobileNumber(mobileNumber) || mobileNumber;
      if (!mobile) {
        throw new Error('Mobilnummer mangler for mobillog.');
      }

      const response = await dataverseApiCall('/oc_mobillogs', {
        method: 'POST',
        headers: { Prefer: 'return=representation' },
        body: JSON.stringify({
          oc_direction: Boolean(direction),
          oc_mobilenumber: mobile,
          oc_userid: userId || null,
          oc_email: email || null,
          oc_name: name || null,
          oc_deviceid: deviceId || null,
          oc_timestamp: timestamp
        })
      });

      return mapMobilLog(response);
    },

    list: async ({ from, to, phone, top = 500 } = {}) => {
      const filters = ['statecode eq 0'];
      const fromOdata = from ? toODataDate(from) : null;
      const toOdata = to ? toODataDate(to) : null;

      if (fromOdata) {
        filters.push(`oc_timestamp ge ${fromOdata}`);
      }
      if (toOdata) {
        filters.push(`oc_timestamp le ${toOdata}`);
      }
      if (phone) {
        const mobile = normalizeMobileNumber(phone) || phone;
        const escaped = escapeODataString(mobile);
        const withoutPlus = escapeODataString(String(mobile).replace(/^\+/, ''));
        filters.push(`(oc_mobilenumber eq '${escaped}' or oc_mobilenumber eq '${withoutPlus}')`);
      }

      const filter = odataFilterParam(filters.join(' and '));
      let path =
        `/oc_mobillogs?$select=${MOBIL_LOG_SELECT}` +
        `&$filter=${filter}&$orderby=oc_timestamp asc&$top=${top}`;

      const records = [];
      for (let page = 0; page < 20 && path; page += 1) {
        const result = await dataverseApiCall(path);
        if (!result) {
          break;
        }
        records.push(...(result.value || []).map(mapMobilLog));
        path = result['@odata.nextLink'] || null;
      }

      return records;
    }
  };
}
